import { GlButton, GlSearchBoxByType } from '@gitlab/ui';
export default {
    name: 'DropdownHeader',
    components: {
        GlButton,
        GlSearchBoxByType
    },
    props: {
        labelsCreateTitle: {
            type: String,
            required: true
        },
        labelsListTitle: {
            type: String,
            required: true
        },
        showDropdownContentsCreateView: {
            type: Boolean,
            required: true
        },
        labelsFetchInProgress: {
            type: Boolean,
            required: false,
            default: false
        },
        searchKey: {
            type: String,
            required: true
        },
        isStandalone: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'close-dropdown',
        'input',
        'search-enter',
        'toggle-dropdown-contents-create-view'
    ],
    expose: [
        'focusInput'
    ],
    computed: {
        dropdownTitle () {
            return this.showDropdownContentsCreateView ? this.labelsCreateTitle : this.labelsListTitle;
        }
    },
    methods: {
        focusInput () {
            this.$refs.searchInput?.focusInput();
        }
    }
};
